/**
 * Lightweight, dependency-free reveal-on-scroll using IntersectionObserver.
 * Replaces the deprecated wow.js library.
 * Honors prefers-reduced-motion and supports dynamic content.
 */
export function initReveal(root) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var container = root || document;
    var elements = container.querySelectorAll('.wow:not(.is-visible):not([data-reveal-observed])');
    if (!elements.length) return;

    var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                var el = entry.target;
                var delayAttr = el.getAttribute('data-reveal-delay') || el.getAttribute('data-wow-delay') || '0';
                var delay = Math.round(parseFloat(delayAttr) * 1000);

                setTimeout(function () {
                    el.classList.add('is-visible');
                }, delay);

                observer.unobserve(el);
            }
        });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    elements.forEach(function (el) {
        el.setAttribute('data-reveal-observed', '');
        observer.observe(el);
    });
    return observer;
}
